module.exports = __webpack_public_path__ + "img/ranking_m_ing.879986cb.png";